import {getInitParams} from '../network/api';
import utils from '../util/util';

const prefix = {
  dev : 'dev-',
  test : 'test-',
  pre : 'pre-',
  online : ''
};

const urls = {
  api : 'api.weclassroom.com',
  report : 's.weclassroom.com'
};

export const version = 'zbzt_LIVE_SDK_VERSION';

export const liveExt = {
  name: 'live',
  version: '1.0.0.0'
};
export const toolExt = {
  name: 'tool',
  version: '1.0.0.0'
};
export const defaultExt = {
  name: 'default_ext',
  version: '1.0.0.0'
};
export const zegoExt = {
  name: 'zego_ext',
  version: '1.0.0.0'
};
export const utilitiesExt = {
  name: 'utilities_ext',
  version: '1.0.0.0'
};
export const talrtcExt = {
  name: 'talrtc_ext',
  version: '1.0.0.0'
};

// 小班=0，大班=1
export const classType = 0;
export const productName = 'zbzt-live-sdk';

export const zegoSdkName = 'zego';
export const talSdkName = 'Tal';
export const rtcSdkName = 'rtc';
export const tmSdkName = 'tm';
export const talrtcSdkName = 'talrtc';

export const extensionInfo = {
  version:{
    default_ext : '1.0.0.0'
    // arora : '1.0.0.1',
    // rtc   : '1.0.0.0',
    // zego  : '1.0.0.0',
    // tool  : '1.0.0.0'
  }
};

export const USER_LOCATION = {
  MAINLAND: 'mainland',
  OVERSEAS: 'overseas'
};

export let config = {
  isHttps: true,
  env: 'test',
  weblog: true,
  businessLinesType: 'xes', // saas | xes
  userLocation: USER_LOCATION.MAINLAND,
  enableZegoAutoplayDialog: true,
};

export const getBaseUrl = (type='api') => {
  const {isHttps,env} = config;
  return `${isHttps ? 'https://' : 'http://'}${prefix[env ? env : 'online']}${urls[type]}`;
};

export const getCloudApiDomain = () => {
  if (window.zbzt_sdk_cloud_api_domain) {
    return window.zbzt_sdk_cloud_api_domain;
  }
  return getBaseUrl();
};

const reportUrls = {
  // test: 'test-dp.weclassroom.com:10443/report',
  // online: 'dp.weclassroom.com:443/report'
  test: 'testdp-s.weclassroom.com/report',
  online: 'dp-s.weclassroom.com/report '
};

const logAddressInit = {
  test: 'live_test_log',
  online: 'live_log'
};

// 从三方服务器获取时间戳
export const timestampUrl = {
  suning: 'https://quan.suning.com/getSysTime.do',
  taobao: 'https://api.m.taobao.com/rest/api3.do?api=mtop.common.getTimestamp'
};

// // 获取初始化数据
// const apiCloudUrl = {
//   saas: {
//     dev: '/saas/live-cloud-control',
//     test: 'https://test-api-cloud-control-zhibo.saasp.vdyoo.com/live-cloud-control',
//     online: 'https://api-cloud-control-zhibo.saasp.vdyoo.com/live-cloud-control'
//   },
//   xes: {
//     dev: '/peiyou/live-cloud-control',
//     test: 'https://test-api-cloud-control-zhibo.speiyou.com/live-cloud-control',
//     online: 'https://api-cloud-control-zhibo.speiyou.com/live-cloud-control'
//   }
// };

// //切换sdk类型
// const apiChangeSdkUrl = {
//   saas: {
//     dev: '/saas/cloud-platform',
//     test: 'https://test-cloud-platform-live.saasp.vdyoo.com/cloud-platform',
//     online: 'https://cloud-platform-live.saasp.vdyoo.com/cloud-platform'
//   },
//   xes: {
//     dev: '/peiyou/cloud-platform',
//     test: 'https://test-cloud-platform-live.speiyou.com/cloud-platform',
//     online: 'https://cloud-platform-live.speiyou.com/cloud-platform'
//   }
// };

const apiCloudUrl = {
  saas: {
    dev: 'https://8-140-113-148.eaydu.com/saas/live-cloud-control',
    test: 'https://test-api-cloud-control-zhibo.saasp.vdyoo.com/live-cloud-control',
    online: 'https://api-cloud-control-zhibo.saasp.vdyoo.com/live-cloud-control'
  },
  xes: {
    dev: 'https://8-140-113-148.eaydu.com/peiyou/live-cloud-control',
    test: 'https://test-api-cloud-control-zhibo.speiyou.com/live-cloud-control',
    online: 'https://api-cloud-control-zhibo.speiyou.com/live-cloud-control'
  }
};

//切换sdk类型
const apiChangeSdkUrl = {
  saas: {
    dev: 'https://8-140-113-148.eaydu.com/saas/cloud-platform',
    test: 'https://test-cloud-platform-live.saasp.vdyoo.com/cloud-platform',
    online: 'https://cloud-platform-live.saasp.vdyoo.com/cloud-platform'
  },
  xes: {
    dev: 'https://8-140-113-148.eaydu.com/peiyou/cloud-platform',
    test: 'https://test-cloud-platform-live.speiyou.com/cloud-platform',
    online: 'https://cloud-platform-live.speiyou.com/cloud-platform'
  }
};

const zegoGateway = {
  [USER_LOCATION.MAINLAND]: {
    dev: 'wss://webliveroom2251703116-api.zego.im/ws',
    test: 'wss://webliveroom2251703116-api.zego.im/ws',
    online: 'wss://webliveroom942270070-api.imzego.com/ws',
    942270070: 'wss://webliveroom942270070-api.imzego.com/ws', // 素养1v1 - 线上
    2135353126: 'wss://webliveroom2135353126-api.imzego.com/ws', // 素养1v1 - 测试
    2251703116: 'wss://webliveroom2251703116-api.zego.im/ws', // 素养小班课 - 线上
    3925774111: 'wss://webliveroom3925774111-api.zego.im/ws', // 素养小班课 - 测试
    1467249911: 'wss://webliveroom1467249911-api.imzego.com/ws', // saas乐乐课堂 - 测试，saas自习室 - 测试
    2007970189: 'wss://webliveroom2007970189-api.imzego.com/ws', // aas乐乐课堂 - 线上
    1669401062: 'wss://webliveroom1669401062-api.imzego.com/ws', // saas自习室 - 线上
    3325152503: 'wss://webliveroom3325152503-api.zego.im/ws', // saas小班/组合小班课 - 测试
    3328955532: 'wss://webliveroom3328955532-api.zego.im/ws', // saas小班/组合小班课 - 线上
    1867191443: 'wss://webliveroom1867191443-api.zego.im/ws', // saas小组/通用课 - 线上
    3557356157: 'wss://webliveroom3557356157-api.zego.im/ws', // saas小组/通用课 - 测试
    1064653827: 'wss://webliveroom1064653827-api.imzego.com/ws', // saas超级体验课 - 测试
    1949725928: 'wss://webliveroom1949725928-api.imzego.com/ws' // saas超级体验课 - 线上
  },
  [USER_LOCATION.OVERSEAS]: {
    dev: 'wss://webliveroom-test.zego.im/ws',
    test: 'wss://webliveroom-test.zego.im/ws',
    online: 'wss://webliveroom.zego.im/ws'
  },
};

const tokenServer = {
  dev: 'https://dev-webrtc.weclassroom.com',
  test: 'https://dev-webrtc.weclassroom.com',
  online: 'https://api2.xueersi.com',
};

export const getApiCloudBaseUrl = () => {
  const {env, businessLinesType} = config;
  return apiCloudUrl[businessLinesType] && apiCloudUrl[businessLinesType][env];
};

export const getApiChangeSdkUrl = () => {
  const {env, businessLinesType} = config;
  return apiChangeSdkUrl[businessLinesType] && apiChangeSdkUrl[businessLinesType][env];
};

export let dabanReportUrl = '';
export let logAddress = '';

export const getReportBaseUrl = () => {
  if (dabanReportUrl) {
    return dabanReportUrl;
  }
  const {env} = config;
  return `https://${reportUrls[env]}`;
};

export const getZegoGateway = (appid) => {
  const {userLocation} = config;
  return zegoGateway[userLocation][appid];
};
export const getLogAddress = () => {
  const {env} = config;
  defaultApi.writeLog(`logAddresshsghsg ${env} ${logAddressInit[env]}`);
  logAddress = logAddressInit[env];
  // return logAddress;
};

export  const getAndSetInitParams = async (args) => {
  const res = await getInitParams(args);
  if (res && res.sdkInfo) {
    defaultApi.writeLog(`云控请求返回参数正常 ${JSON.stringify(res)}, ${JSON.stringify(res.sdkInfo)}`);
    return res.sdkInfo[0].sdkName;
  } else {
    defaultApi.writeLog(`云控请求返回参数错误 ${JSON.stringify(res)}`);
  }
};

export const getapiChangeSdkUrl = () => {
  const {env, businessLinesType} = config;
  return apiChangeSdkUrl[businessLinesType] && apiChangeSdkUrl[businessLinesType][env];
};

export const getTokenServerUrl = () => {
  const {env} = config;
  return tokenServer[env];
};

export const getGUID = () => {
  const guid = window.localStorage.getItem('zbzt_live_sdk_guid');
  if (guid) {
    return guid;
  } else {
    const newGuid = utils.generateGUID();
    window.localStorage.setItem('zbzt_live_sdk_guid', newGuid);
    return newGuid;
  }
};

export default {
  version,
  extensionInfo,
  getBaseUrl,
  config
};
